import { createContext, type ReactNode, useContext, useState } from "react";

type LayoutContextProps = {
	editMode: boolean;
	setEditMode: (value: boolean) => void;
	mobilePreview: boolean;
	setMobilePreview: (value: boolean) => void;
};

const LayoutContext = createContext<LayoutContextProps | undefined>(undefined);

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
	const [editMode, setEditMode] = useState(false);
	const [mobilePreview, setMobilePreview] = useState(false);

	return (
		<LayoutContext.Provider
			value={{
				editMode,
				setEditMode,
				mobilePreview,
				setMobilePreview,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
};

export const useLayout = () => {
	const ctx = useContext(LayoutContext);
	if (!ctx) throw new Error("useLayout should be used inside of <LayoutProvider>");
	return ctx;
};

export const StaticLayoutProvider = ({
	children,
	editMode,
	mobilePreview,
}: {
	children: ReactNode;
	editMode: boolean;
	mobilePreview: boolean;
}) => {
	const parentContext = useLayout();

	return (
		<LayoutContext.Provider
			value={{
				...parentContext,
				editMode: editMode,
				mobilePreview: mobilePreview,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
};
